import React, { useEffect, useRef, useState } from "react";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { AiOutlineHeart, AiOutlineShoppingCart } from "react-icons/ai";
import { FiShoppingCart, FiUser, FiUsers } from "react-icons/fi";
import { IoCallOutline } from "react-icons/io5";
import { NavLink, useLocation, useParams, useSearchParams } from "react-router-dom";
import Car from "../../../assets/images_td/icons/car.svg";
import { useAppDispatch, useAppSelector } from "../../../redux/hook";
import { getTotalAmount } from "../../../redux/slice/useCartSlice";
import { useGetCartByUserQuery, useGetListProductQuery, useGetProductListQuery } from "../../../utils/api/product/product.api";
import MobileCategoryModal from "../../user/ParcoursAchat/modal/MobileCategoryModal";
import { MAIN_NAV_LINKS } from "../FrontMainNav/FrontMainNav";
import CategoriesList from "./CategoriesList";
import ConnexionModal from "./modal/ConnexionModal";
import SearchForm from "./SearchForm";

/** Logo All in Tech (desktop + mobile). Ne pas utiliser images_td/logo.svg (Tout Dedans). */
const LOGO_ALL_IN_TECH = "/AllInTech_logo.png";

const FrontHeader = () => {
  const dispatch = useAppDispatch();
  const { user, token } = useAppSelector((s) => s?.user);
  const { cartItems } = useAppSelector((state) => state.cart);
  // const { data:carts } = useGetCartByUserQuery(user?.slug);
  const [modalConnexion, setModalConnexion] = useState(false);
  let [searchParams] = useSearchParams();
  const [searchCategory, setSearchCategory] = useState<any>();
  const [searchSousCategory, setSearchSousCategory] = useState<any>();
  const [query, setQuery] = React.useState({
    category: searchParams?.get("category") || "",
    min: searchParams?.get("min") || "",
    max: searchParams?.get("max") || "",
    orderBy: searchParams?.get("orderBy") || "",
  });

  const [value, setValue] = React.useState<any>({
    min: searchParams?.get("min") || 0,
    max: searchParams?.get("max") || 9000000,
  });
  let { state } = useLocation();

  useEffect(() => {
    dispatch(getTotalAmount());
  }, [cartItems]);

  const [show, setShow] = useState(false);

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 40) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div>
      <Navbar
        expand="lg"
        className="frontheader-component headering"
        id="navbar"
      >
        <div
          className={`headering-second-level-header ${
            scrolled ? "scrolled" : ""
          }`}
        >
          <Navbar.Brand
            href="/"
            className="d-flex align-items-center no-view-mobile"
          >
            <img src={LOGO_ALL_IN_TECH} alt="All in Tech" className="app-logo" />
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            className="no-view-mobile"
          />
          <div className="header-mobile-first-row no-view-desktop">
            <Navbar.Brand
              href="/"
              className="d-flex align-items-center header-mobile-brand"
            >
              <img src={LOGO_ALL_IN_TECH} alt="All in Tech" className="app-logo app-logo-mobile" />
            </Navbar.Brand>
            <div className="header-mobile-icons-row">
              <NavLink
                to="/panier"
                className="btn nav-link menu-link position-relative header-mobile-cart-link"
                aria-label="Panier"
              >
                <FiShoppingCart className="header-mobile-cart-icon" size={22} />
                <span className="counter-shop-notif counter-shop-notif-mobile">
                  {cartItems?.length ?? 0}
                </span>
              </NavLink>
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
            </div>
          </div>
          <Navbar.Collapse id="basic-navbar-nav">
            <div className="front-main-nav-mobile no-view-desktop">
              {MAIN_NAV_LINKS.map(({ to, label }) => (
                <NavLink
                  key={to}
                  to={to}
                  className={({ isActive }) =>
                    `front-main-nav-mobile-link${isActive ? " active" : ""}`
                  }
                  end={to === "/"}
                  onClick={() =>
                    (
                      document.querySelector(".navbar-toggler") as HTMLElement
                    )?.click()
                  }
                >
                  {label}
                </NavLink>
              ))}
            </div>
            <Nav className="navbar navbar-expand-lg navbar-light firstheader-costum nav-header-custom">
              <div className="w-100 header-navbar-contents-container">
                <div className="bloc-flex-info-user-header-content">
                  <div className="bloc-flex-info-user-header">
                    <div className="search-form-container no-view-mobile">
                      <SearchForm />
                    </div>
                    <div className="categorie-btn-container no-view-mobile">
                      <CategoriesList />
                    </div>
                  </div>
                </div>
                <div className="container-nav-content-nvlink p-2">
                  <Nav.Link href="#home">
                    {!token ? (
                      <button
                        onClick={() => setModalConnexion(true)}
                        className="btn nav-link menu-link d-flex align-items-center"
                      >
                        <FiUser size={22} />
                        <span className="ps-2">Se Connecter</span>
                      </button>
                    ) : (
                      <NavLink
                        to={`/mon-compte/profil`}
                        className="btn nav-link menu-link"
                      >
                        <FiUser />
                        <span className="ps-2">Mon compte</span>
                      </NavLink>
                    )}

                    <ConnexionModal
                      modalConnexion={modalConnexion}
                      setModalConnexion={setModalConnexion}
                    />
                    <MobileCategoryModal
                      show={show}
                      setShow={setShow}
                      value={value}
                      setValue={setValue}
                      setSearchCategory={setSearchCategory}
                      setSearchSousCategory={setSearchSousCategory}
                      query={query}
                      setQuery={setQuery}
                      catgoryId={state?.catgoryId}
                    />
                  </Nav.Link>

                  {user ? (
                    <NavLink
                      to="/mon-compte/favoris"
                      className="btn nav-link menu-link"
                    >
                      <AiOutlineHeart />
                      <span className="ps-2">Mes favoris</span>
                    </NavLink>
                  ) : (
                    ""
                  )}
                  <NavLink
                    to="/panier"
                    className="btn nav-link menu-link position-relative no-view-mobile"
                  >
                    <FiShoppingCart style={{ fontSize: 15 }} />
                    <span className="ps-2">Panier</span>
                    <span className="counter-shop-notif">
                      {cartItems?.length}
                    </span>
                  </NavLink>
                </div>
              </div>
            </Nav>
          </Navbar.Collapse>
          <div className="container-menu-search-bloc-and-cart no-view-desktop position-relative mt-3">
            <div className="search-form-container header-mobile-search-wrapper">
              <SearchForm />
            </div>
          </div>
        </div>
      </Navbar>
    </div>
  );
};

export default FrontHeader;
